import { rgba } from 'polished';
import React, { FunctionComponent } from 'react';
import styled from 'styled-components';

interface AvatarLoadingProps {
  className?: string;
  loading: number;
}

const AvatarLoading: FunctionComponent<AvatarLoadingProps> = ({
  className,
  loading,
}) => {
  return (
    <div className={className || ''}>
      <LoadingBar className="bar" progress={loading} />
    </div>
  );
};

export default styled(AvatarLoading)`
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-color: ${({ theme }) => rgba(theme.colors.black, 0.4)};
`;

const LoadingBar = styled.div<{ progress: number }>`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: calc(100% - 20px);
  height: 5px;
  border-radius: 100px;
  background-color: ${({ theme }) => theme.colors.differentBackground};

  &:after {
    content: '';
    position: absolute;
    top: 0;
    right: ${({ progress }) => (progress ? `calc(100% - ${progress}%)` : 'auto')};
    bottom: 0;
    border-radius: 100px;
    left: 0;
    background-color: ${({ theme }) => theme.colors.accent};
  }
`;
